import PropTypes from 'prop-types'
import React from 'react'
import InputRadioField from './InputRadio.Field'
import InputRadioLabel from './InputRadio.Label'
import './index.scss'
import { View } from 'components/View'

class InputRadio extends React.Component {
  static Field = InputRadioField

  static Label = InputRadioLabel

  static propTypes = {
    children: PropTypes.arrayOf(PropTypes.element).isRequired
  }

  render () {
    return (
      <View
        style={{
          flexDirection: View.DIRECTION.ROW,
          alignItems: View.ALIGN.CENTER,
          justifyContent: View.JUSTIFY.CENTER
        }}
      >
        {this.props.children}
      </View>
    )
  }
}

export default InputRadio
